{
  "schemaVersion": 1,
  "coordinateRule": "Each team receives distinct (x,y) points. y is the start of the archived x±1 downward foot probe; it must not be replaced by a scan from zero.",
  "maps": {
    "1030": {
      "width": 1100,
      "height": 1334,
      "evidence": "Measured safe points on the pinned original 1030 fore.map: three separate upper platforms per team, body clearance and ±6px source walking verified. The 2009 DB PosX/PosX1 values have not been recovered; these are explicit terrain-based fallback points.",
      "teams": [
        [{ "x": 310, "y": 129 }, { "x": 237, "y": 284 }, { "x": 220, "y": 459 }],
        [{ "x": 790, "y": 129 }, { "x": 862, "y": 284 }, { "x": 880, "y": 459 }]
      ]
    },
    "1001": {
      "width": 2000,
      "height": 1425,
      "evidence": "Measured main-rainbow-bridge fallback on pinned original 1001 fore.map; y=900 probes below the floating clouds. Six points are separated by 200px within each side; ±15px slope changes are at most 5px. The 2009 DB PosX/PosX1 values have not been recovered.",
      "teams": [
        [{ "x": 250, "y": 900 }, { "x": 450, "y": 900 }, { "x": 650, "y": 900 }],
        [{ "x": 1350, "y": 900 }, { "x": 1550, "y": 900 }, { "x": 1750, "y": 900 }]
      ]
    }
  }
}
